import { FormsModule, NgForm } from '@angular/forms';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LoginServico } from '../servicos/login.servico';
import { Router, ActivatedRoute } from '@angular/router';
import { MatButtonModule } from '@angular/material';
import { UtilServico } from '../servicos/util.servico';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import swal from 'sweetalert2';

declare var jquery: any;
declare var $: any;

//declare var swal: any;

export class TermoLGPD{
  RPPS_LGP_URL:string;
  RPPS_LGPD_TEXTO:string;
  RPPS_LGPD_TEXTO_URL:string;
  PORTAL_LGP_HABILITAR:string;
}

@Component({
    selector: 'app-adm',
    encapsulation: ViewEncapsulation.None,

    templateUrl: './adm.component.html',
    styleUrls: ['./adm.component.scss']
})

export class AdmComponent implements OnInit {
    LOGIN: any;
    DADOSESQUECEUSENHA: any;
    Mostrar: any;
    TotalRegistro: number;
    Url: string;
    urlSisprev: string;
    TermoLGPD:TermoLGPD = new TermoLGPD();
    textoTermoPolitica: string = '';
    isTermoAceito: boolean = false;
    carregouTramite: boolean = false;
    parametro:any = [];

    constructor(
        private http: Http,
        private loginServico: LoginServico,
        private router: Router,
        private UtilServico: UtilServico
        //|| window.location.href.indexOf("192.168") > 0 || window.location.href.indexOf("localhost") > 0 ||
    ) {

      //if (window.location.href.indexOf("localhost") > 0 || window.location.href.indexOf("192.168") > 0 || window.location.href.indexOf("10.243") > 0) {
        this.http.get("assets/config.json").subscribe(data => { this.Url = data.json().BASE_WEB_API; this.getTermoLGPD(); this.GetParametro(); this.urlSisprev = data.json().SISPREV_WEB_API; });
      //}
      //else {
        //this.Url = window.location.href.replace('/portal/inicial', '/webapiportalmunicipios').replace('/portal/login', '/webapiportalmunicipios').replace('/portal/undefined', '/webapiportalmunicipios').replace('/NovoPortalMunicipios/login', '/webapiportalmunicipios');
        //console.log(this.Url);
      //}


        //this.Url = window.location.href.replace('/PortalSeguradoEspiritoSanto/login', '/webapiportales');

    }

    ngOnInit() {
        this.loginServico.logout();
        this.LOGIN = {};
        this.DADOSESQUECEUSENHA = {};

    }
    AcessarSistema() {
      if(this.carregouTramite && this.isTermoAceito == false) {
        swal.fire({
          title: "Atenção!",
          type: "warning",
          text: "Para realizar o login é necessário aceitar o Termo de uso e Política de privacidade."
        });
      }
      else
      {
        this.Mostrar = true;
        let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' ,'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS','Access-Control-Allow-Origin': '*'});
        let options = new RequestOptions({ headers: headers });
        this.http.post(this.Url+"/api/Login/Autenticar", JSON.stringify({ usuario: this.LOGIN.USUARIO, senha: this.LOGIN.SENHA }), options)
            .map((response: Response) => response.json())
            .subscribe(
            data => {
                //console.log(data);
                //localStorage.setItem('DadosConfiguracoes', JSON.stringify(Object.assign(data,{ URL: this.Url })));
                localStorage.setItem('AcessoAdm', JSON.stringify(Object.assign(data,{ URL: this.Url, URL_SISPREV: this.urlSisprev })));
                this.router.navigate(['/inicial']);
                this.Mostrar = false;
            },
            error => {
                this.Mostrar = false;
                if (error.status == 0) {
                    swal.fire({
                        title: "Atenção!",
                        type: "warning",
                        text: "Não foi possível conectar no servidor banco de dados!"
                    });
                }
                else {
                  swal.fire({
                        title: "Atenção!",
                        type: "warning",
                        text: "Usuário não encontrado ou senha inválida!"
                    });
                }
            }
        );
      }
    }

    aceitarTermoPoliticaPrivacidade() {
      this.getTermoLGPD();
      this.isTermoAceito = !this.isTermoAceito;

      console.log(this.isTermoAceito);
    }

    GetParametro() {
      let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS','Access-Control-Allow-Origin': '*' });
      let options = new RequestOptions({ headers: headers });

      this.http.get(this.Url + "/api/Login/GetParametro/", options).subscribe(data => {
        this.parametro = data.json()[0];
      }, error => {
      });
    }

    getTermoLGPD() {
      let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS','Access-Control-Allow-Origin': '*' });
      let options = new RequestOptions({ headers: headers });

      this.http.get(this.Url + "/api/Login/GetTermoLGPD/", options).subscribe(data => {
        this.TermoLGPD = Object.assign(this.TermoLGPD, data.json()[0])
        this.textoTermoPolitica =  "<div class='quebrarLinha'>"+this.TermoLGPD.RPPS_LGPD_TEXTO.replace("@url", `<a class='underline-text'  href='${this.TermoLGPD.RPPS_LGP_URL}'>${this.TermoLGPD.RPPS_LGPD_TEXTO_URL}</a>`+"</div>");
        this.parametro = data;
;        if (this.TermoLGPD.RPPS_LGPD_TEXTO != "" && this.TermoLGPD.RPPS_LGP_URL != "" && this.TermoLGPD.RPPS_LGPD_TEXTO_URL != "" && this.TermoLGPD.PORTAL_LGP_HABILITAR == "S") {
          this.carregouTramite = true;
        }
      }, error => {
        console.log(error);
        console.log(this.Url);
        this.carregouTramite = false;
      });
    }




    AlterSenha() {
        //this.Mostrar = true;
        let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
        let options = new RequestOptions({ headers: headers });
        if (this.DADOSESQUECEUSENHA.NOVA !== this.DADOSESQUECEUSENHA.CONFIRMA) {
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "A nova senha não confere com o conteúdo digitado em Confirma Senha!"
          });
        }
        else {
          this.http.post(this.Url+"/api/Login/GetTrocarSenha", JSON.stringify({ LOGIN: this.DADOSESQUECEUSENHA.CPF,SENHA: this.DADOSESQUECEUSENHA.NOVA, DATA_NASC:this.DADOSESQUECEUSENHA.DATA_NASC,MAT_ORG: this.DADOSESQUECEUSENHA.MAT_ORG}), options)
            .map((response: Response) => response.json())
            .subscribe(
              data => {
                this.Mostrar = false;
                this.TotalRegistro = data.Total;
                if (this.TotalRegistro == 0) {
                  swal.fire({
                    title: "Atenção!",
                    type: "error",
                    text: "Dados não conferem com cadastro em nosso banco de dados!"
                  });
                }
                else {
                  this.LOGIN.USUARIO = this.DADOSESQUECEUSENHA.CPF;
                  this.LOGIN.SENHA = this.DADOSESQUECEUSENHA.NOVA;
                  $(document.body).removeClass("modal-open");
                  $(".modal-backdrop").remove();

                  this.Mostrar = true;
                  let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' ,'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS','Access-Control-Allow-Origin': '*'});
                  let options = new RequestOptions({ headers: headers });
                  this.http.post(this.Url+"/api/Login/Autenticar", JSON.stringify({ usuario: this.LOGIN.USUARIO, senha: this.LOGIN.SENHA }), options)
                      .map((response: Response) => response.json())
                      .subscribe(
                      data => {
                          //console.log(data);
                          //localStorage.setItem('DadosConfiguracoes', JSON.stringify(Object.assign(data,{ URL: this.Url })));
                          localStorage.setItem('AcessoAdm', JSON.stringify(Object.assign(data,{ URL: this.Url })));
                          this.router.navigate(['/inicial']);
                          this.Mostrar = false;
                      },
                      error => {
                          this.Mostrar = false;
                          if (error.status == 0) {
                              swal.fire({
                                  title: "Atenção!",
                                  type: "warning",
                                  text: "Não foi possível conectar no servidor banco de dados!"
                              });
                          }
                          else {
                            swal.fire({
                                  title: "Atenção!",
                                  type: "warning",
                                  text: "Usuário não encontrado ou senha inválida!"
                              });
                          }
                      }
                  );
                }
              },
              error => {
                this.Mostrar = false;
              }
            );
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/login/adm.component.ts